import "../../pages/new/new.scss"

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import { getExaminers } from '../../services/instructorService';
import { getReviewers } from '../../services/instructorService';
import { getAllStudents } from '../../services/studentService';
import { getThesisStatusById } from '../../services/thesisAssignedService';
import { toast } from 'react-toastify';
import TextBox from './TextBox';
export const AssignExaminer = () => {
    const { thesisStatusId } = useParams();
    const [submission, setSubmission] = useState({
        date_submitted:'', 
        enrollment_number:'',
        id:'',
        mentor1_name:'',
        mentor2_name:'',
        report_type:'',
        report_month:'',
        report_link:'',
        folder_link:'',
        presentation_link:'',
        presentation_video_link:'',
        turnitin:'',
        reviewer_id1:'',
        reviewer_id2:'',
        student_id:'',
        student_name:'',
        thesis_abstract:'',
        thesis_id:'',
        thesis_title:''
    });

    const [examiners, setExaminers] = useState([]);
    const [selectedExaminerId1, setSelectedExaminerId1] = useState(null);
    const [selectedExaminerId2, setSelectedExaminerId2] = useState(null);
    const [reviewers, setReviewers] = useState([]);
    const [selectedReviewerId1, setSelectedReviewerId1] = useState(null);
    const [selectedReviewerId2, setSelectedReviewerId2] = useState(null);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);

    const [fileLinks, setFileLinks] = useState({});

    const [uploadedFiles, setUploadedFiles] = useState({});
        
    const reportUploaded = uploadedFiles?.Report;
    const presentationUploaded = uploadedFiles?.Presentation_File;
    const presentationVideoUploaded = uploadedFiles?.Presentation_Video;
    const turnitinUploaded = uploadedFiles?.Turnitin;
    const rebuttalUploaded = uploadedFiles?.Rebuttal_Report_File;
    const codeDemoUploaded = uploadedFiles?.Code_Demo_File;

    const fetchThesisStatusById = async (thesisStatusId) => {
        try {
            const data = await getThesisStatusById(thesisStatusId);
           // console.log(data);
            setSubmission(data.data);
            setSelectedExaminerId1(data.data.examiner_id1);
            setSelectedExaminerId2(data.data.examiner_id2);
            setSelectedReviewerId1(data.data.reviewer_id1);
            setSelectedReviewerId2(data.data.reviewer_id2);

            return data.data;
        } catch (err) {

        }
    };
    
    const fetchExaminerList = async () => {
        try {
            const response = await getExaminers();
          //  console.log(response.data)
            setExaminers(response.data);

            // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };

    const fetchReviewerList = async () => {
        try {
            const response = await getReviewers();
           // console.log(response.data)
            setReviewers(response.data);

            // Set course details from API response
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };

    useEffect(() => {
        fetchThesisStatusById(thesisStatusId);
        fetchExaminerList();
        fetchReviewerList();
    }, []);
    useEffect(() => {
        if (thesisStatusId) {
            const path = window.location.pathname;
            if (path.includes('view-assigned')) {
                setEditMode(true);
            }
           

            fetchThesisStatusById(thesisStatusId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);
        }
    }, [thesisStatusId]);

    useEffect(() => {
    if (!thesisStatusId) return;

    axiosInstance
      .get(`/files/status/${thesisStatusId}`)
      .then(res => setUploadedFiles(res.data.data))
      .catch(console.error);

  }, [thesisStatusId]);

    const handleAddExaminer1Select = (event) => {
        setSelectedExaminerId1(event.target.value);
    };
    const handleAddExaminer2Select = (event) => {
        setSelectedExaminerId2(event.target.value);
    };
    const handleAddReviewer1Select = (event) => {
        setSelectedReviewerId1(event.target.value);
    };
    const handleAddReviewer2Select = (event) => {
        setSelectedReviewerId2(event.target.value);
    };


   

    const goBack = (e) => {
            navigate('/assignexaminers');
    };

    const validateForm = () => {
        const errors = {};
        
        if (selectedExaminerId1 && selectedExaminerId2 && selectedExaminerId1==selectedExaminerId2) {
            errors.examiner_id2 = 'Both examiners cannot be same';
        }

        if (submission.is_feedback_by_examiner1 && submission.examiner_id1!=selectedExaminerId1) {
            errors.examiner_id1 = 'Examiner1 has already given feedback. Hence cannot be changed';
        }

        if (submission.is_feedback_by_examiner2 && submission.examiner_id2!=selectedExaminerId2) {
            errors.examiner_id2 = 'Examiner2 has already given feedback. Hence cannot be changed';
        }

        if (selectedReviewerId1 && selectedReviewerId2 && selectedReviewerId1==selectedReviewerId2) {
            errors.reviewer_id2 = 'Both reviewers cannot be same';
        }

        if (submission.is_feedback_by_reviewer1 && submission.reviewer_id1!=selectedReviewerId1) {
            errors.reviewer_id1 = 'Reviewer1 has already given feedback. Hence cannot be changed';
        }

        if (submission.is_feedback_by_reviewer2 && submission.reviewer_id2!=selectedReviewerId2) {
            errors.reviewer_id2 = 'Reviewer2 has already given feedback. Hence cannot be changed';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
      
    const handleClick = (e) => {
       // console.log("inside handle click")
        if(e.target.value)
        window.open(e.target.value, '_blank');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
       // console.log("inside submit");
        var response = '';
        try {
            if (viewMode) {
                navigate('/assignexaminers');
            }
            else  {
                var editSubmission = {
                    id:thesisStatusId,
                    reviewerId1:selectedReviewerId1,
                    reviewerId2:selectedReviewerId2,
                    examinerId1:selectedExaminerId1,
                    examinerId2:selectedExaminerId2,
                    studentId:submission.student_id
                }
                // Update course if in edit mode
                response = await axiosInstance.put('/updateThesisSubmissionExaminers', editSubmission, { showToastOnResponse: true });
            }
           
           // console.log(response);
            navigate('/assignexaminers');

        } catch (error) {
            console.log('Error saving submission. Please try again later.');
            console.log(error);
        }
    };

    const fetchFileLink = async (fileType) => {
        try {
          const res = await axiosInstance.get("/files/presign-download", {
            params: {
              thesisStatusId,
              fileType
            }
          });

          setFileLinks(prev => ({
            ...prev,
            [fileType]: {
              url: res.data.data.downloadUrl,
              originalFilename: res.data.data.originalFilename
            }
          }));
        } catch (e) {
          console.error(`Failed to fetch ${fileType}`, e);
        }
      };

      useEffect(() => {
          if (!thesisStatusId) return;
      
          if (reportUploaded) fetchFileLink("Report");
          if (presentationUploaded) fetchFileLink("Presentation_File");
          if (presentationVideoUploaded) fetchFileLink("Presentation_Video");
          if (turnitinUploaded) fetchFileLink("Turnitin");
          if (rebuttalUploaded) fetchFileLink("Rebuttal_Report_File");
          if (codeDemoUploaded) fetchFileLink("Code_Demo_File");
      
        }, [
          thesisStatusId,
          reportUploaded,
          presentationUploaded,
          presentationVideoUploaded,
          turnitinUploaded,
          rebuttalUploaded,
          codeDemoUploaded
        ]);

      const isDriveLink = (value) =>
        typeof value === "string" && value.startsWith("http");

    return (
        <div>
            <div className="top">
                <h1>{editMode ? 'Assigned Examiners'  : 'Assign Examiner'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                        <div className="formInput">
                            <label>Student Name</label>
                            <input type="text"
                                name="student_name"
                                value={submission.student_name}
                                disabled={true}
                                className={errors.student_name ? 'error' : ''} />
                            {errors.student_name && <div className="error-text">{errors.student_name}</div>}
                        </div>
                        <div className="formInput">
                            <label>Enrollment Number</label>
                            <input type="text"
                                name="enrollment_number"
                                value={submission.enrollment_number}
                                disabled={true}
                                className={errors.enrollment_number ? 'error' : ''} />
                            {errors.enrollment_number && <div className="error-text">{errors.enrollment_number}</div>}
                        </div>
                        <div className="formInput">
                            <label>Mentor1</label>
                            <input type="text"
                                name="mentor1_name"
                                value={submission.mentor1_name}
                                disabled={true}
                                className={errors.mentor1_name ? 'error' : ''} />
                            {errors.mentor1_name && <div className="error-text">{errors.mentor1_name}</div>}
                        </div>
                        <div className="formInput">
                            <label>Mentor2</label>
                            <input type="text"
                                name="mentor2_name"
                                value={submission.mentor2_name}
                                disabled={true}
                                className={errors.mentor2_name ? 'error' : ''} />
                            {errors.mentor2_name && <div className="error-text">{errors.mentor2_name}</div>}
                        </div>
                        <div className="formInput">
                            <label>Report Type</label>
                            <input type="text"
                                name="report_type"
                                value={submission.report_type}
                                disabled={true}
                                className={errors.report_type ? 'error' : ''} />
                            {errors.report_type && <div className="error-text">{errors.report_type}</div>}
                        </div>

                        <div className="formInput">
                            <label>Report Month</label>
                            <input type="text"
                                name="report_month"
                                value={submission.report_month}
                                disabled={true}
                                className={errors.report_month ? 'error' : ''} />
                            {errors.report_month && <div className="error-text">{errors.report_month}</div>}
                        </div>

                        <div className="formInput">
                            <label>Thesis Title</label>
                            <TextBox type="text"
                                name="thesis_title"
                                value={submission.thesis_title}
                                disabled={true}
                                className={errors.thesis_title ? 'error' : ''} />
                            {errors.thesis_title && <div className="error-text">{errors.thesis_title}</div>}
                        </div>
                        <div className="formInput">
                            <label>Folder Link</label>
                            <input type="text"
                                name="folder_link"
                                value={submission.folder_link}
                                readOnly
                                onClick={handleClick}
                                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                                className={errors.folderLink ? 'error' : ''} />
                            {errors.folder_link && <div className="error-text">{errors.folder_link}</div>}
                        </div>
                        <div className="formInput">
                            <label>Report File</label>
                            {submission.report_link && isDriveLink(submission.report_link) && (
                                <div>
                                    <a href={submission.report_link} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.report_link && <div className="error-text">{errors.report_link}</div>}
                            {reportUploaded && !isDriveLink(submission.report_link) && fileLinks.Report?.url && (
                                <div>
                                    <a href={fileLinks.Report.url} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                        </div>
                        <div className="formInput">
                            <label>Presenatation File</label>
                            {submission.presentation_link && isDriveLink(submission.presentation_link) && (
                                <div>
                                    <a href={submission.presentation_link} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentation_link && <div className="error-text">{errors.presentation_link}</div>}
                            {presentationUploaded && !isDriveLink(submission.presentation_link) && fileLinks.Presentation_File?.url && (
                                <div>
                                    <a href={fileLinks.Presentation_File.url} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                        </div>

                        <div className="formInput">
                            <label>Presentation Video</label>
                            {submission.presentation_video_link && isDriveLink(submission.presentation_video_link) && (
                                <div>
                                    <a href={submission.presentation_video_link} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentation_video_link && <div className="error-text">{errors.presentation_video_link}</div>}
                            {presentationVideoUploaded && !isDriveLink(submission.presentation_video_link) && fileLinks.Presentation_Video?.url && (
                                <div>
                                    <a href={fileLinks.Presentation_Video.url} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                        </div>
                        
                        <div className="formInput">
                                <label>Turnitin</label>
                                {submission.turnitin && isDriveLink(submission.turnitin) && (
                                <div>
                                    <a href={submission.turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                            {turnitinUploaded && !isDriveLink(submission.turnitin) && fileLinks.Turnitin?.url && (
                                <div>
                                    <a href={fileLinks.Turnitin.url} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                                            </div>
                       
                        <div className="formInput">
                            <label>Select Examiner1</label>
                            <select id="styled-dropdown"
                                name="examiner_id1"
                                value={selectedExaminerId1}
                                onChange={handleAddExaminer1Select}
                               
                            >
                                <option value="">Select an examiner</option>
                                {examiners && examiners.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}, {option.email}
                                    </option>
                                ))}
                            </select>
                            {errors.examiner_id1 && <div className="error-text">{errors.examiner_id1}</div>}
                        </div>

                        <div className="formInput">
                            <label>Select Examiner2</label>
                            <select id="styled-dropdown"
                                name="examiner_id2"
                                value={selectedExaminerId2}
                                onChange={handleAddExaminer2Select}
                               
                            >
                                <option value="">Select an examiner</option>
                                {examiners && examiners.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}, {option.email}
                                    </option>
                                ))}
                            </select>
                            {errors.examiner_id2 && <div className="error-text">{errors.examiner_id2}</div>}
                        </div>

                        <div className="formInput">
                            <label>Select Reviewer1</label>
                            <select id="styled-dropdown"
                                name="reviewer_id1"
                                value={selectedReviewerId1}
                                onChange={handleAddReviewer1Select}
                               
                            >
                                <option value="">Select a reviewer</option>
                                {reviewers && reviewers.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}, {option.email}
                                    </option>
                                ))}
                            </select>
                            {errors.reviewer_id1 && <div className="error-text">{errors.reviewer_id1}</div>}
                        </div>

                        <div className="formInput">
                            <label>Select Reviewer2</label>
                            <select id="styled-dropdown"
                                name="reviewer_id2"
                                value={selectedReviewerId2}
                                onChange={handleAddReviewer2Select}
                               
                            >
                                <option value="">Select a reviewer</option>
                                {reviewers && reviewers.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}, {option.email}
                                    </option>
                                ))}
                            </select>
                            {errors.reviewer_id2 && <div className="error-text">{errors.reviewer_id2}</div>}
                        </div>
                        <div className="buttons">
                            <button type="submit">{editMode ? 'Update' : 'Save'}</button>
                            <button onClick={goBack}>Back</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
};


